<template>
  <div class="layout container-fluid g-0">
    <div class="d-flex justify-content-between">
      <div class="px-0 sidebar-wrapper overflow-auto position-fixed vh-100">
        <the-sidebar />
      </div>

      <div class="px-0 main-content overflow-hidden">
        <div>
          <router-view></router-view>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div
        v-if="selectSurveyStatus"
        @click="closePopup()"
        class="
          modal-layout
          position-fixed
          d-flex
          justify-content-center
          align-items-center
        "
      >
        <select-surveys-for-compare />
      </div>
    </transition>
  </div>
</template>

<script>
import TheSidebar from "@/components/the-sidebar.vue";
import SelectSurveysForCompare from "@/components/dashboard/compare-surveys/select-surveys-for-compare.vue";

export default {
  name: "Layout",
  components: {
    TheSidebar,
    SelectSurveysForCompare,
  },
  computed: {
    selectSurveyStatus() {
      return this.$store.getters["mainStats/selectSurveysForCompareStatus"];
    },
  },
  methods: {
    closePopup() {
      this.$store.dispatch("mainStats/hideSelectSurveys");
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  width: 10.5rem;
  z-index: 11;
  transition: $transition-300ms;

  &:hover {
    width: 20rem;
    background-color: #3f3f3f;
  }
}

.main-content {
  width: calc(100vw - 10.5rem);
  margin-left: auto;
  min-height: 100vh;
}
</style>
